/**
 * Control-room gate: signed-out → /login; a RESTRICTED session (recovery-code login) → /reenrol only;
 * a failed probe is an explicit error, never an empty control room.
 */
import { Button, Card, StateView } from '@hopex/ui';
import { Navigate } from '@tanstack/react-router';
import { useAdminSession } from '../session.tsx';
import { AdminShell } from './AdminShell.tsx';

export function AdminGate() {
  const { state, refresh } = useAdminSession();
  if (state.status === 'anonymous') return <Navigate to="/login" replace />;
  if (state.status === 'ready')
    return state.me.restricted ? <Navigate to="/reenrol" replace /> : <AdminShell me={state.me} />;
  return (
    <div className="grid min-h-dvh place-items-center bg-canvas p-4 text-fg">
      {state.status === 'loading' ? (
        <p aria-busy="true" className="m-0 text-fg-muted">
          در حال بارگذاری…
        </p>
      ) : (
        <Card className="w-full max-w-md p-6">
          <StateView
            kind="error"
            title="ارتباط با سرور مدیریت برقرار نشد"
            description="وضعیت ورود دریافت نشد. دوباره تلاش کنید."
            action={<Button onPress={() => void refresh()}>تلاش دوباره</Button>}
          />
        </Card>
      )}
    </div>
  );
}
